<template>
    <div>
        <!--提示标题栏-->
        <div style="width: 88%;height: 40px;line-height:40px;">
            <div style="
            background-color: #adadad;
            width: 150px;
            height: 40px;
            text-align: center;
            vertical-align: middle;
            float: left;">
                选择售货机
            </div>
            <div style="
            background-color: #adadad;
            margin-left: 2px;
            width: 40%;
            height: 40px;
            text-align: center;
            color: #adadad;
            float: left;">
                选择售货机
            </div>
        </div>
        <div style="width: 44.3%;height: 40px;line-height:40px;
        background-color: #cccccc;margin-top: 5px">
            <el-form :inline="true">
                <el-form-item>
                    <el-button type="primary" style="margin-left: 25px" @click="add()"
                               :disabled="isCheckStatus">添加
                    </el-button>
                    <el-button type="primary" @click="deleteDevice('',1)"
                               :disabled="deleteStatus">批量删除
                    </el-button>
                    <el-input v-model="machineName" placeholder="售货机名称" style="width: 30%"></el-input>
                    <el-button type="primary" @click="findValidDevice()">
                        查询
                    </el-button>
                    <el-button type="primary" @click="resetValidDevice()" :disabled="isReset">
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--工具条-->
        <!--<el-col :span="24" class="toolbar" style="padding: 5px 0px;width: 39.9%;
        height: 45px;
        line-height: 45px;
        text-align: left;
        background-color: #cccccc">
            <el-form :inline="true">
                <el-form-item>
                    <el-button type="primary" style="margin-left: 25px" @click="add()"
                    :disabled="isCheckStatus">添加</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="deleteDevice('',1)" :disabled="deleteStatus">批量删除</el-button>
                </el-form-item>
                <el-form-item prop="name">
                    <el-input v-model="machineName" placeholder="模糊搜索" style="width: 50%"></el-input>
                    <el-button type="primary" @click="findValidDevice()">
                        查询
                    </el-button>
                    <el-button type="primary" @click="resetValidDevice()" :disabled="isReset">
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </el-col>-->
        <!--已选择多少台设备-->
        <div class="validNum" style="margin-top: 20px;padding: 10px;color: #212121">
            共 <span style="color: red">{{count}}</span> 台设备
        </div>
        <!--表格-->
        <el-table ref="multipleTable" :data="tableValidData" tooltip-effect="dark" style="width: 100%;"
                  @selection-change="SelectChange">
            <el-table-column label="序号" type="selection" width="55"></el-table-column>
            <el-table-column prop="deviceName" label="售货机名称" width="250"></el-table-column>
            <el-table-column prop="machine_id" label="售货机Id" width="200"></el-table-column>
            <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
            <el-table-column prop="delete" label="操作" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button @click="deleteDevice(scope.row,0)" type="text"
                               size="small" v-if="isCheckStatus==false">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页显示栏-->
        <div class="block" style="text-align: right">
            <el-pagination
                    @current-change="CurrentChange"
                    @size-chahange="SizeChange"
                    :current-page="page"
                    :page-count="count"
                    :page-sizes="sizes"
                    :page-size="size"
                    :total="count"
                    layout=" total, prev, pager, next, jumper"
            >
            </el-pagination>
        </div>
        <el-form>
            <!--上一步按钮 下一步按钮-->
            <el-form-item style="margin-left: 16.5%">
                <el-button type="primary" @click="lastStep('ecxForm')"
                           id="last_step" :disabled="isorgsubmit">上一步
                </el-button>
                <el-button type="primary" @click="nextStep('ecxForm')"
                           id="next_step" :disabled="isorgsubmit">下一步
                </el-button>
            </el-form-item>
        </el-form>
        <!-- 弹窗新增标签-->
        <el-dialog title="添加售货机" style="text-align: left;font-style: revert;"
                   :visible.sync="dialogFormVisible" :modal-append-to-body="false">
            <!--搜索活动-->
            <div style="text-align: left;margin-left: 20px">
                <el-input v-model="deviceName" placeholder="售货机名称" style="width: 30%;"></el-input>
                <el-button type="primary" @click="findDevices()">
                    查询
                </el-button>
                <el-button type="primary" @click="resetDevice()" :disabled="isReset2">
                    重置
                </el-button>
            </div>
            <!--表格分页-->
            <el-table ref="multipleTable" :data="tableAllData" tooltip-effect="dark" style="width: 100%;"
                      @selection-change="addSelectChange">
                <el-table-column label="序号" type="selection" width="55"></el-table-column>
                <el-table-column label="售货机名称" prop="deviceName" width="200">
                    <!--<template slot-scope="scope">{{ scope.row.date }}</template>-->
                </el-table-column>
                <el-table-column prop="deviceId" label="售货机Id" width="120"></el-table-column>
                <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
            </el-table>
            <!--分页显示栏-->
            <div class="block" style="text-align: right">
                <el-pagination
                        @current-change="addCurrentChange"
                        @size-chahange="addSizeChange"
                        :current-page="currentpage"
                        :page-count="pagesCount"
                        :page-sizes="pagesizes"
                        :page-size="pagesize"
                        :total="pagesCount"
                        layout=" total, prev, pager, next, jumper"
                >
                </el-pagination>
            </div>
            <!--添加，取消按钮-->
            <div style="text-align: right;margin-right: 60px">
                <el-button type="primary" @click="addDevice()">
                    添加
                </el-button>
                <el-button type="primary" style="margin-left: 60px" @click="dialodclose()">
                    取消
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "ChoiceDevice",
        props: ["actID", "status"],
        data() {
            return {
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [5, 10, 15],//条数列
                pagesize: 5,//行数
                activeNum: 0, //默认起始行数
                endNum: 5,//默认结束行数
                tableAllData: [], // 全部分页组件传回的分页后数据
                selectDevicesList: [],//添加页签选中的数据集合
                //------------已选择的----------
                page: 1,//当前页数默认是1
                count: 0,//总数默认0
                sizes: [5, 10, 15],//条数列
                size: 5,//行数
                startIndex: 0, //默认起始行数
                endIndex: 5,//默认结束行数
                tableValidData: [], // 已选择分页组件传回的分页后数据
                selectList: [],// 已选择页签选中的数据集合
                validDeviceId: [],//已选择的设备ID
                isexpSecond: false,
                isorgsubmit: false,
                machineName: null,
                storeId: "",//租户ID
                token: "111111111",
                deviceName: "",//设备名称
                dialogVisible: false,
                /*弹窗选择*/
                dialogFormVisible: false,
                isReset: true,//已选择设备页面
                isReset2: true,//添加设备页面
                deleteStatus: true,
                isCheckStatus: false
            }
        },
        created() {
            this.storeId = this.getcookie("storeId");
            if (this.status == "1") {
                /*编辑状态查询*/
                this.getValidDevices()
            } else if (this.status == "2") {
                /*查看状态查询*/
                this.isCheckStatus = true
                this.getValidDevices()
            }
        },
        methods: {
            /*添加页面选中*/
            addSelectChange(val) {
                this.selectDevicesList = val;
            },
            /*已选择页签的选中*/
            SelectChange(val) {
                this.selectList = val;
                if (this.status == "2") {
                    this.deleteStatus = true
                } else {
                    if (this.selectList.length > 0) {
                        this.deleteStatus = false
                    } else {
                        this.deleteStatus = true
                    }
                }

            },
            /*添加页面*/
            addSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pagesize = val
                this.activeNum = (val * this.currentpage) - val;
                this.endNum = (val * this.currentpage)
                this.getData(this.deviceName)
                //数目变更
            },
            addCurrentChange(val) {
                this.currentpage = val;
                this.activeNum = (this.pagesize * val) - this.pagesize
                this.endNum = (this.pagesize * val)
                this.getData(this.deviceName)
            },
            /*已选择页签*/
            SizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.size = val
                this.startIndex = (val * this.page) - val;
                this.endIndex = (val * this.page)
                this.getValidDevices(this.machineName)
                //数目变更
            },
            CurrentChange(val) {
                this.page = val;
                this.startIndex = (this.size * val) - this.size
                this.endIndex = (this.size * val)
                this.getValidDevices(this.machineName)
            },
            /*根据选中的数据分割出设备ID---添加页签*/
            getAddDeviceId(data) {
                var deviceid = "";
                if (data.length > 0) {
                    if (data.length > 1) {
                        for (let i = 0; i < data.length; i++) {
                            if (i < data.length - 1) {
                                deviceid += data[i].deviceId + ",";
                            } else {
                                deviceid += data[i].deviceId
                            }
                        }
                    } else {
                        deviceid = data[0].deviceId
                    }
                }
                return deviceid;
            },
            /*根据选中的数据分割出设备ID---已选择页签*/
            getDeleteDeviceId(data) {
                var deviceid = "";
                if (data.length > 0) {
                    if (data.length > 1) {
                        for (let i = 0; i < data.length; i++) {
                            if (i < data.length - 1) {
                                deviceid += data[i].machine_id + ",";
                            } else {
                                deviceid += data[i].machine_id
                            }
                        }
                    } else {
                        deviceid = data[0].machine_id
                    }
                }
                return deviceid;
            },
            /*弹窗关闭*/
            dialodclose() {
                this.currentpage = 1//当前页数默认是1
                this.pagesCount = 0 //总数默认0
                this.pagesize = 5//行数
                this.activeNum = 0 //默认起始行数
                this.endNum = 5//默认结束行数
                this.deviceName = ''
                this.dialogFormVisible = false;
                this.getValidDevices()
            },
            /*模糊查询*/
            findValidDevice() {
                this.isReset = false
                this.page = 1//当前页数默认是1
                // this.Count = 0 //总数默认0
                this.size = 5//行数
                this.startIndex = 0 //默认起始行数
                this.getValidDevices(this.machineName)
            },
            /*模糊重置*/
            resetValidDevice() {
                this.isReset = true
                this.machineName = null
                this.page = 1//当前页数默认是1
                this.size = 5//行数
                this.startIndex = 0 //默认起始行数
                this.endIndex=5
                this.getValidDevices(this.machineName)
            },
            /*添加页面查询设备*/
            findDevices() {
                this.isReset2 = false;
                this.currentpage = 1//当前页数默认是1
                // this.pagesCount = 0 //总数默认0
                this.pagesize = 5//行数
                this.activeNum = 0 //默认起始行数
                // this.endNum = 5//默认结束行数
                this.getData(this.deviceName)
            },
            /*添加页面重置设备*/
            resetDevice() {
                this.isReset2 = true;
                this.deviceName = null
                this.currentpage = 1//当前页数默认是1
                this.pagesize = 5//行数
                this.activeNum = 0 //默认起始行数
                this.endNum=5
                this.getData(this.deviceName)
            },
            /*弹出添加设备页面*/
            add() {
                this.dialogFormVisible = true;
                this.getData(null)
            },
            /*删除选中设备--0单个删除；1.批量删除*/
            deleteDevice(row, flag) {
                var params = {};
                var msg = '';
                if (flag == "0") {
                    params = {actId: this.actID, machineIds: row.machine_id};
                    msg = "你确定要删除这条数据么？删除是不可恢复的";
                } else if (flag == "1") {
                    if (this.selectList.length > 0) {
                        params = {actId: this.actID, machineIds: this.getDeleteDeviceId(this.selectList)};
                        msg = "你确定要删除选中的数据么？删除是不可恢复的";
                        console.log("批量删除：" + this.selectList)
                        console.log("批量删除：" + this.getDeleteDeviceId(this.selectList))
                    } else {
                        this.$message({showClose: true, message: '请选择要删除的设备', type: 'error'});
                        return;
                    }
                }
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //数据请求
                    this.loading = true
                    //异步请求
                    this.$http.post(this.actManagerHost + this.deleteDeviceURL, params)
                        .then(response => {
                            if (response.body.Code == "200") {
                                this.deleteStatus = true
                                this.$message({showClose: true, message: '删除成功', type: 'success'});
                                this.getValidDevices(null);
                            } else if (response.body.Code == "400") {
                                this.$message({showClose: true, message: '参数错误', type: 'error'});
                            } else if (response.body.Code == "500") {
                                this.$message({showClose: true, message: '网络异常', type: 'error'});
                            }
                        }, function (response) {
                            this.$message({showClose: true, message: '网络异常', type: 'error'});
                        })
                })
            },
            /*添加设备*/
            addDevice() {
                if (this.actID == null && this.actID == " " && this.actID == "") {
                    this.$message({showClose: true, message: "没有拿到活动编号", type: 'error'});
                } else {
                    console.log(this.selectDevicesList.length)
                    if (this.selectDevicesList.length <= 0) {
                        this.$message({showClose: true, message: "请先选择售货机", type: 'error'});
                        return false
                    } else {
                        //数据请求
                        this.loading = true
                        var params = {actId: this.actID, machineIds: this.getAddDeviceId(this.selectDevicesList)};
                        // console.log("id="+this.getDeviceId(this.selectDevicesList))
                        // console.log("URL="+this.actManagerHost+this.addDeviceURL+"\n"+this.actID)
                        //异步请求
                        this.$http.post(this.actManagerHost + this.addDeviceURL, params)
                            .then(response => {
                                if (response.status === 200) {
                                    if (response.body.Code == "200") {
                                        this.$message({showClose: true, message: '添加成功', type: 'success'});
                                        this.dialodclose();
                                    } else {
                                        this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                                    }
                                }
                            }, function (response) {
                                this.$message({showClose: true, message: '网络异常', type: 'error'});
                            })

                    }
                }
            },
            /*查询已选择设备*/
            getValidDevices(name) {
                //数据请求
                this.loading = true
                var params = '';
                if (name == null) {
                    params = "?iDisplayStart=" + this.startIndex + "&iDisplayLength="
                        + this.size + "&actId=" + this.actID
                        + "&tenantId=" + this.storeId;

                } else {
                    params = "?iDisplayStart=" + this.startIndex + "&iDisplayLength="
                        + this.size + "&actId=" + this.actID
                        + "&tenantId=" + this.storeId + "&machineName=" + name;
                }
                //异步请求
                this.$http.get(this.actManagerHost + this.getValidDeviceURL + params)
                    .then(response => {
                        console.log(response.body)
                        if (response.status === 200) {
                            if (response.body.Code == "200") {
                                this.count = response.body.Data.count
                                this.tableValidData = response.body.Data.machineList
                                // for (let i = 0; i < this.tableValidData.length; i++) {
                                //     this.validDeviceId[i] = this.tableValidData[i].machine_id;
                                // }
                                // console.log(this.validDeviceId)
                                this.loading = false;
                            } else if (response.body.Code == "400") {
                                this.$message({showClose: true, message: '参数错误', type: 'error'});
                            } else if (response.body.Code == "500") {
                                this.$message({showClose: true, message: '异常', type: 'error'});
                            }

                        }
                    }, function (response) {
                        this.$message({showClose: true, message: '网络异常', type: 'error'});
                    })
            },
            /*获取设备列表数据*/
            getData(name) {
                //数据请求
                this.loading = true
                // var url = "http://47.99.129.28:8765/vueFeign/findDevices?active=0&len=5" +
                //     "&tenantId=store001&Token=11111&deviceName=1";
                var url = "/vueFeign/findDevices";
                // var url = "http://192.168.10.198:8765/vueFeign/findDevices";
                var params = "";
                if (name == null) {
                   params = "?active="+this.activeNum+"&len="+this.pagesize+"&tenantId="+this.storeId+"&Token="+this.token;
                } else {
                    params = "?active="+this.activeNum+"&len="+this.pagesize+"&tenantId="+this.storeId
                        +"&Token="+this.token+"&deviceName="+name;
                }
                //异步请求
                this.$http.get(this.actManagerHost+url+params)
                    .then(response => {
                        if (response.status === 200) {
                            console.log(response.body)
                            this.pagesCount = response.body.Data.count
                            this.tableAllData = response.body.Data.Devices

                            this.loading = false;
                            // console.log(this.tableAllData)
                        }
                    }, function (response) {
                        console.log("fail")
                        this.$message({showClose: true, message: '网络异常', type: 'error'});
                    })
            },
            /*卡片跳转*/
            sendMsgToParent: function (step, id) {
                this.$emit("listenToChildEvent", step, id)
            },
            nextStep(formName) {
                this.sendMsgToParent("4", this.actID)
            },
            lastStep(formName) {
                this.sendMsgToParent("2", this.actID)
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ChoiceDevice.vue?4bf73b5c